var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSquiggleAlt = function SvgSquiggleAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lines",
    width: 448.74,
    height: 229.95,
    viewBox: "0 0 448.74 229.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.84,15.63c-69.21,56.93-240.64,58.1-294.29,59.47-70.59,1.8-115.15,11.66-112.56,32.8,1.19,9.7,13.31,19.37,43.72,18.33,66.94-2.29,133.56-14.95,226.64-34.89,116.09-24.87,127.77-8,72.21,9.05-20.09,6.17-61.18,13.02-98.81,20.82-20.33,4.22-140.33,26.88-122.46,45.41,.54,.56,1.23,1.06,2.09,1.41,3.51,1.46,15.43,.56,15.66,.55,61.99-2.92,238.62-69.14,237.13-30.89-.44,11.24-17.18,12.61-64.2,17.09-42.94,4.1-81.52,38.97-36.87,58.42",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSquiggleAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/squiggle-alt.0d78c166.svg";
export { ForwardRef as ReactComponent };